export default "__VITE_ASSET__DulT6qhN__"